export default "__VITE_ASSET__C74pjV43__"